<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm"  ref="dataForm"
                 label-width="150px">
            <el-row>
                <el-col :span="12"><el-form-item label="姓名" prop="username">
                    <div class="min-input-class">{{dataForm.username}}</div>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="工号" prop="workNumber">

                    <div class="min-input-class">{{dataForm.workNumber}}</div>
                </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="申请时间" prop="tjsj">
                    <div class="min-input-class">{{dataForm.tjsj}}</div>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="补卡时间"  prop="kssj">
                    <div class="min-input-class">{{dataForm.bksj}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="状态"  prop="status">

                    <div class="min-input-class">
                        <el-tag v-if="dataForm.status=='0'" type="danger">未审核</el-tag>
                        <el-tag v-else-if="dataForm.status=='1'" type="danger">审核不通过</el-tag>
                        <el-tag v-else-if="dataForm.status=='2'" type="success">已审批</el-tag>
                        <el-tag v-else-if="dataForm.status=='3'" type="success">已审核</el-tag>
                        <el-tag v-else type="info">已撤销</el-tag>
                    </div>
                </el-form-item>
               </el-col>
                <el-col :span="12"><el-form-item label="审核人">
                    <div class="min-input-class">{{dataForm.shrxm}}</div>
                </el-form-item></el-col>
            </el-row>

            <el-row>
                <el-col :span="12"> <el-form-item label="审核时间"  >
                    <div class="min-input-class">{{dataForm.shsj}}</div>
                </el-form-item></el-col>
                <el-col :span="12">  <el-form-item label="审批人" >
                    <div class="min-input-class">{{dataForm.sprxm}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="审批时间" >
                    <div class="min-input-class">{{dataForm.spsj}}</div>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="补卡事由" >
                    <div class="min-input-class">{{dataForm.bksy}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><el-form-item label="流程" >
                    <el-timeline :reverse="true">
                        <el-timeline-item
                                v-for="(activity, index) in activities"
                                :key="index"
                                :color="activity.color"
                                :size="'large'"
                                :timestamp="activity.timestamp">
                            {{activity.content}}
                        </el-timeline-item>
                    </el-timeline>
                </el-form-item></el-col>
            </el-row>

        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            return {

                visible: false,
                activities:[],
                dataForm: {
                id: '',
                userid: '',
                username: '',
                qjlx: '',bksj: '',
                jssj: '',
                qjsc: '',
                shrid: '',
                shrxm: '',
                shsj: '',
                sprid: '',
                sprxm: '',
                spsj: '',
                status: '',
                bksy: '',
                tjsj: '',
                qjlxmc: '',
                bmmc: '',
                workNumber: ''
                }
            }
        },
        methods: {
            init (id) {
                this.dataForm = id
                this.visible = true
                this.activities=[]
                this.$nextTick
                (() => {
                    console.log('111111111111')
                    if(this.dataForm.status ==='0') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                    } else if( this.dataForm.status ==='1') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        var obj1={}
                        obj1.content = this.dataForm.shrxm+' 审核被拒'
                        obj1.timestamp = this.dataForm.shsj
                        obj1.color='#e81018'
                        this.activities.push(obj1);
                    }else if( this.dataForm.status ==='3') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        if(this.dataForm.shrxm){
                            var obj1={}
                            obj1.content = this.dataForm.shrxm+' 审核通过'
                            obj1.timestamp = this.dataForm.shsj
                            obj1.color='#0bbd87'
                            this.activities.push(obj1);
                        }
                    }else if( this.dataForm.status ==='2') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        if(this.dataForm.shrxm) {
                            var obj1 = {}
                            obj1.content = this.dataForm.shrxm + ' 审核通过'
                            obj1.timestamp = this.dataForm.shsj
                            obj1.color = '#0bbd87'
                            this.activities.push(obj1);
                        }
                        var obj2={}
                        obj2.content = this.dataForm.sprxm+' 审批通过'
                        obj2.color='#0bbd87'
                        obj2.timestamp = this.dataForm.spsj
                        this.activities.push(obj2);
                    }else  {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        var obj2={}
                        obj2.content = this.dataForm.username+' 撤销'
                        obj2.timestamp = ''
                        obj2.color='#e81018'
                        this.activities.push(obj2);
                    }
                })

            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
